import { webmeetService } from '@/utils/apis'

export const getMeetingByID = async (meetingId: string) => {
  return await webmeetService.getMeeting({ meetingId })
}
